import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editSocioEcoRequest: ['response'],
    editSocioEcoSuccess: ['response'],
    editSocioEcoFailure: ['error'],
})

export const editSocioEcoTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const editSocioEcoRequest = state => state.merge({ success: null })

const editSocioEcoSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const editSocioEcoFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_SOCIO_ECO_REQUEST]: editSocioEcoRequest,
    [Types.EDIT_SOCIO_ECO_SUCCESS]: editSocioEcoSuccess,
    [Types.EDIT_SOCIO_ECO_FAILURE]: editSocioEcoFailure,
})
